export default __webpack_public_path__ + "static/media/XEMP-20.fad9ec5b.jpg";